import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { useEffect } from "react";

const routeNames = {
  "": "Home",
  "about": "About Us",
  "services": "Services",
  "projects": "Projects",
  "gallery": "Gallery",
  "testimonials": "Testimonials",
  "contact": "Contact",
  "blog": "Blog",
  "scaffolding-rental": "Scaffolding Rental",
  "shuttering-material-on-rent": "Shuttering Material",
  "cuplock-scaffolding": "Cuplock Scaffolding",
  "acrow-span-props": "Acrospan Props",
  "industrial-scaffolding": "Industrial Scaffolding",
  "scaffolding-on-hire": "Scaffolding on Hire",
  "scaffolding-rental-delhi": "Delhi",
  "scaffolding-rental-noida": "Noida",
  "scaffolding-rental-hyderabad": "Hyderabad",
  "scaffolding-rental-vizag": "Vizag",
};

export function useCanonical() {
  const location = useLocation();
  useEffect(() => {
    const canonical = document.querySelector("link[rel='canonical']");
    const url = `https://www.amarpreet.in${location.pathname === "/" ? "/" : location.pathname}`;
    if (canonical) {
      canonical.setAttribute("href", url);
    }
  }, [location.pathname]);
}

export default function Breadcrumbs() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  if (pathSegments.length === 0) return null;

  const crumbs = pathSegments.map((segment, index) => {
    const path = "/" + pathSegments.slice(0, index + 1).join("/");
    const name = routeNames[segment] || segment.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
    const isLast = index === pathSegments.length - 1;
    return { path, name, isLast };
  });

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.amarpreet.in/" },
      ...crumbs.map((crumb, i) => ({
        "@type": "ListItem",
        "position": i + 2,
        "name": crumb.name,
        "item": `https://www.amarpreet.in${crumb.path}`
      }))
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
      <nav aria-label="Breadcrumb" className="bg-slate-100 border-b border-slate-200" data-testid="breadcrumbs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <ol className="flex items-center flex-wrap text-sm">
            <li className="flex items-center">
              <Link to="/" className="text-slate-500 hover:text-yellow-600 transition-colors flex items-center" data-testid="breadcrumb-home">
                <Home className="w-3.5 h-3.5 mr-1" />
                Home
              </Link>
            </li>
            {crumbs.map((crumb) => (
              <li key={crumb.path} className="flex items-center">
                <ChevronRight className="w-3.5 h-3.5 mx-2 text-slate-400" />
                {crumb.isLast ? (
                  <span className="text-slate-700 font-medium" data-testid={`breadcrumb-${crumb.name.toLowerCase().replace(/\s+/g, "-")}`}>
                    {crumb.name}
                  </span>
                ) : (
                  <Link to={crumb.path} className="text-slate-500 hover:text-yellow-600 transition-colors">
                    {crumb.name}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
}
